// frontend/src/App.js
// Role: Main App component that renders the news list

import React from 'react';
import NewsList from './pages/NewsList';
import './App.css';

function App() {
  return (
    <div className="App">
      <NewsList />
    </div>
  );
}

export default App; 